import {makeAutoObservable, transaction} from "mobx";
import {PageEntity} from "../entity/page-entity";
import {SpecimenEntity} from "../entity/specimen-entity";
import {TableDisplayEnum} from "../entity/enum/home";
import {getHomePageInfo} from "../http/home";

export class SearchStore {

    constructor() {
        makeAutoObservable(this);
    }

    public searchKey:string|undefined;
    public condition = this.getDefaultCondition()
    public pagination:PageEntity = new PageEntity();
    public dataSource: SpecimenEntity[] = [];
    public plantDetail!:SpecimenEntity;
    public isExpend: boolean = false;
    public displayType: String = TableDisplayEnum.List;
    public detailModalOpen: boolean = false;
    public modelTotal:string = "0"
    public total:string = "0"
    public imageTotal:string = "0"
    public videoTotal:string = "0"

    public setSearchKey (key:string) {
        this.searchKey = key;
    }

    public setExpend(isExpend:boolean){
        this.isExpend = isExpend;
    }

    public setDisplayType(type: string){
        this.displayType = type;
    }

    public setDetailModalOpen(open: boolean) {
        this.detailModalOpen = open;
    }

    public setPlantDetail(detail: SpecimenEntity) {
        this.plantDetail = detail;
    }

    public setDataSource(list: SpecimenEntity[]){
        this.dataSource = list;
    }

    public resetQuery = () => {
        this.condition = this.getDefaultCondition();
    }

    public getInformation = () => {
        getHomePageInfo({})
            .then((res) => {
                transaction(() => {
                    this.total = res.data ? res.data.total : "0"
                    this.imageTotal = res.data ? res.data.imageTotal : "0"
                    this.videoTotal = res.data ? res.data.videoTotal : "0"
                    this.modelTotal = res.data ? res.data.modelTotal : "0"
                })
            }).catch((e) => {
            console.log("error:" + e.message)
        })
    }
    private getDefaultCondition() {
        return {
            libraryCode: "",
            specimenName: "", // 中文名
            gatherer: "",
            gatherDate: "",
            gatherDateEnd: "",
            gatherDateStart:"",
            gatherNumber:"",
            province:"",
            district:"",
            specimenCanonicalName: "",
            authenticateEr:"",
        };
    }

    public clear = () => {
        this.searchKey = "";
        this.isExpend = false;
        this.displayType = TableDisplayEnum.List;
        this.detailModalOpen = false;
        this.condition = this.getDefaultCondition();
        this.pagination = new PageEntity();
    }
}